<template>
    <div v-if="isGoodsReceiptBatch">
        <b-alert show variant="warning">
            <strong>Er is geen gebatchte order om dit product aan toe te voegen.</strong><br/>
            Leg apart voor plaatsing in loods.
        </b-alert>
        <b-button @click="$emit('success')" variant="primary">Voltooid</b-button>
    </div>
    <div v-else>
        <b-alert show variant="warning">
            <strong>Er is geen gebatchte order om dit product aan toe te voegen.</strong><br/>
        </b-alert>
        <b-button @click="$emit('fail')" variant="secondary">Volgende product</b-button>
    </div>
</template>

<script>
import {BATCH_MODEL_TYPE_GOODS_RECEIPT} from "../../../data/batchModelTypes";

export default {
    name: "SpecialProcessProductNotInRequestedDrq",

    props: {
        batchModelType: {required: true, type: String},
    },

    data() {
        return {}
    },

    computed: {
        isGoodsReceiptBatch() {
            return this.batchModelType === BATCH_MODEL_TYPE_GOODS_RECEIPT
        },
    },

    mounted() {
    },

    methods: {
        getIdentifier() {
            return 'product_not_in_requested_drq'
        },
        isRequired(batchModelType, productIdentifier, dispatchRequest, sortingLocation, isLastScan) {
            return Promise.resolve(!dispatchRequest)
        },
        onShow() {
        },
    },
}
</script>

<style scoped>

</style>
